var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-wrapper"},[_c('div',{ref:"myPie",staticClass:"pie"}),_c('div',{staticClass:"pie-num"},[_vm._v(_vm._s(_vm.score))])])
}
var staticRenderFns = []

export { render, staticRenderFns }